// extracted by mini-css-extract-plugin
module.exports = {"list_of_items":"ReferedInvoiceList_list_of_items__12Le5","buttons":"ReferedInvoiceList_buttons__1Ya3-","button":"ReferedInvoiceList_button__3YPXa"};